import { ProductTagDetailPage } from '@/features/product-tag/pages/ProductTagDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-tag/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_tag.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductTagDetailPage,
})
